import client from 'data/client';
import { CDError } from 'utils/error';

export type Variables = {
  reportType: string;
  dateStart: string;
  dateEnd: string;
};

export type ResponseStatus = {};

export const requestReportAction = async ({
  reportType,
  dateStart,
  dateEnd,
}: Variables) => {
  try {
    const data = {
      reportType,
      dateStart,
      dateEnd,
    };
    return await client.post<ResponseStatus>('pdf-reports/', data, {
      headers: { 'content-type': 'application/json' },
    });
  } catch (error) {
    // @ts-ignore
    throw new CDError(undefined, error?.response?.data);
  }
};
